import { createFileRoute } from '@tanstack/react-router';
import { WebhooksTab } from '@/features/integrations';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/all/webhooks')({
  component: withRumPageRendered(WebhooksTab),
});
